const HospitalIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <circle cx='12' cy='12' r='12' fill='#F0F0F3' />
    <path
      d='M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM10.5 7V10.5H7V13.5H10.5V17H13.5V13.5H17V10.5H13.5V7H10.5Z'
      fill='#84ACED'
    />
  </svg>
);

export default HospitalIcon;
